import { SearchCriteria } from '../types'
import axiosInstance from '../utils/axiosInstance'

export const getStringFilterOptions = async (
  searchURL: string,
  searchCriteria: SearchCriteria
) => {
  try {
    const res = await axiosInstance.post(
      `${searchURL}${searchCriteria.search_key}`,
      {
        fields: [],
        search_criteria: [searchCriteria],
      }
    )
    if (res) return res.data.content
  } catch (err) {
    console.log(err)
  }
  return []
}

export const getStringFilterOptionsEntityManager = async (
  searchURL: string,
  searchCriteria: SearchCriteria[]
) => {
  try {
    const res = await axiosInstance.post(
      `${searchURL}${searchCriteria[0].search_key}`,
      {
        fields: [],
        search_criteria: searchCriteria,
      }
    )
    if (res) return res.data.content
  } catch (err) {
    console.log(err)
  }
  return []
}

export const getStringFilterOptionsWithoutHeader = async (
  searchURL: string,
  searchCriteria: SearchCriteria
) => {
  try {
    const res = await axiosInstance.post(
      `${searchURL}${searchCriteria.search_key}`,
      {
        fields: [],
        search_criteria: [searchCriteria],
      },
      {
        headers: {
          'X-TenantId': '',
        },
      }
    )
    if (res) return res.data.content
  } catch (err) {
    console.log(err)
  }
  return []
}
